module.exports = __webpack_public_path__ + "static/TT2-evergreen-page-screening-sales-learn-iStock-640107874.8030ca90.jpg";